export default "__VITE_ASSET__B8hG2MZP__"